import  gql  from 'graphql-tag'

export const CREATE_CREDIT_REQUEST_STAGES = gql`mutation creditRequestStage($input: CreditRequestStageMutationInput!){
    creditRequestStage(input: $input){
        creditRequestStage{
            id
            code
            name
            isActive
        }
        errors{
            field
            messages
        }
    }
}`;